import {ModalBody, ModalCloseButton, ModalFooter, ModalHeader, ModalTitle} from '@components/ui/modal-atoms'
import {Trans, useTranslation} from '@/translations/i18n.tsx'
import {formatLocaleDate} from '@/dates.ts'
import {Button} from '@components/ui/button'
import {Spinner} from '@components/ui/spinner'
import {useScheduleAssignment} from '@features/assignment/queries/useScheduleAssignment'
import {Assignment} from '@features/assignment/types.ts'
import {Dialog, DialogClose, DialogContent} from '@components/ui/dialog'

export const ScheduleDateModal = ({
    assignmentId,
    onClose,
    selectedDate
}: {
    assignmentId: Assignment['id']
    onClose: () => void
    selectedDate: string
}) => {
    const {t} = useTranslation()
    const scheduleAssignmentMutation = useScheduleAssignment({
        assignmentId,
        options: {
            onSuccess: onClose
        }
    })

    return (
        <Dialog open={true} onOpenChange={onClose}>
            <DialogContent className="w-120" showCloseButton={false}>
                <ModalHeader>
                    <DialogClose
                        data-slot="dialog-close"
                        render={<ModalCloseButton disabled={scheduleAssignmentMutation.isPending} />}
                    />
                </ModalHeader>

                <ModalBody>
                    <ModalTitle>
                        <Trans
                            i18nKey="assignment:descriptions:accepted_dates_shared:schedule_confirmation_title"
                            components={{b: <b />}}
                            values={{date: formatLocaleDate(selectedDate, 'PPPPp')}}
                        />
                    </ModalTitle>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={onClose} variant="tertiary" disabled={scheduleAssignmentMutation.isPending}>
                        {t('commons:close')}
                    </Button>
                    <Button
                        type="submit"
                        disabled={scheduleAssignmentMutation.isPending}
                        onClick={() => scheduleAssignmentMutation.mutate(selectedDate)}
                    >
                        {t('assignment:descriptions:schedule')}
                        {scheduleAssignmentMutation.isPending && <Spinner size={20} />}
                    </Button>
                </ModalFooter>
            </DialogContent>
        </Dialog>
    )
}
